class FreeShippingMeter extends HTMLElement {
    constructor() {
        super();
    }

    static freeShippingText = window.free_shipping_text.free_shipping_message;
    static freeShippingText1 = window.free_shipping_text.free_shipping_message_1;
    static freeShippingText2 = window.free_shipping_text.free_shipping_message_2;
    static freeShippingText3 = window.free_shipping_text.free_shipping_message_3;
    static freeShippingText4 = window.free_shipping_text.free_shipping_message_4;
    static classLabel1 = 'progress-30';
    static classLabel2 = 'progress-60';
    static classLabel3 = 'progress-100';
    static freeshipPrice = Number(window.free_shipping_price);

    connectedCallback() {
        this.freeShippingEligible = 0;
        this.progressBar = this.querySelector('[data-shipping-progress]');
        this.messageElement = this.querySelector('[data-shipping-message]');
        this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';
        this.shipVal = window.free_shipping_text.free_shipping_1;
        this.progressMeter = this.querySelector('[ data-free-shipping-progress-meter]');

        this.addEventListener('change', this.onCartChange.bind(this));

        this.initialize();
    }

    initialize() {
        Shopify.getCart((cart) => {
            this.cart = cart;
            this.calculateProgress(cart);
        })
    }

    onCartChange(e) {
        this.initialize();
    }

    calculateProgress(cart) {
        // Shopify Ajax amounts use hundredths, including JPY (e.g. ¥3300 = 330000).
        const currency = cart.currency || Shopify.currency?.active || window.shop_currency;
        const shopCurrency = window.shop_currency;
        const activeCurrency = Shopify.currency?.active;
        const rate = currency === shopCurrency ? 1 :
            (currency === activeCurrency ? Number(Shopify.currency?.rate) : NaN);
        const cartTotal = Number(cart.total_price);
        this.freeShippingEligible = 0;

        // Never compare different currencies or announce eligibility without a valid rate.
        if (!currency || !Number.isFinite(rate) || rate <= 0 ||
            !Number.isFinite(cartTotal) || cartTotal < 0 ||
            !Number.isFinite(FreeShippingMeter.freeshipPrice) || FreeShippingMeter.freeshipPrice <= 0) {
            this.hidden = true;
            this.style.display = 'none';
            return;
        }

        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency', currency: currency
        });
        const digits = formatter.resolvedOptions().maximumFractionDigits;
        const scale = Math.pow(10, digits);
        // Round up to a spendable unit so the displayed target never understates the threshold.
        const threshold = Math.ceil(FreeShippingMeter.freeshipPrice * rate * scale - 1e-8) / scale;
        const thresholdCents = Math.round(threshold * 100);
        const remainingCents = Math.max(0, thresholdCents - cartTotal);
        const freeShipBar = Math.min(100, cartTotal * 100 / thresholdCents);
        this.hidden = false;
        this.style.display = 'block';
        this.shipVal = cartTotal >= thresholdCents ?
            window.free_shipping_text.free_shipping_1 : window.free_shipping_text.free_shipping_2;
        this.progressBar.classList.toggle('progress-hidden', cartTotal === 0);
        this.freeShippingEligible = cartTotal >= thresholdCents ? 1 : 0;
        const text = this.getText(cartTotal, thresholdCents, remainingCents, formatter);
        this.setProgressWidthAndText(freeShipBar, text, this.getClassLabel(freeShipBar));
    }

    getText(cartTotal, thresholdCents, remainingCents, formatter) {
        // Use text nodes and a dedicated class to avoid the legacy span.money converter.
        const money = (cents) => {
            const span = document.createElement('span');
            span.className = 'shipping-money';
            span.textContent = formatter.format(cents / 100);
            return span.outerHTML;
        };
        if (cartTotal === 0) {
            return '<span>' + FreeShippingMeter.freeShippingText + ' ' + money(thresholdCents) + '!</span>';
        }
        if (cartTotal >= thresholdCents) {
            return FreeShippingMeter.freeShippingText1;
        }
        return '<span>' + FreeShippingMeter.freeShippingText2 + ' </span>' + money(remainingCents) +
            '<span> ' + FreeShippingMeter.freeShippingText3 + ' </span><span class="text">' +
            FreeShippingMeter.freeShippingText4 + '</span>';
    }

    getClassLabel(freeShipBar) {
        let classLabel;

        if (freeShipBar === 0) {
            classLabel = 'none';
        } else if (freeShipBar <= 30) {
            classLabel = FreeShippingMeter.classLabel1;
        } else  if (freeShipBar <= 60) {
            classLabel = FreeShippingMeter.classLabel2;
        } else if (freeShipBar < 100) {
            classLabel = FreeShippingMeter.classLabel3;
        } else {
            classLabel = 'progress-free'
        }

        return classLabel;
    }
    
    resetProgressClass(classLabel) {
        this.progressBar.classList.remove('progress-30');
        this.progressBar.classList.remove('progress-60');
        this.progressBar.classList.remove('progress-100');
        this.progressBar.classList.remove('progress-free');

        this.progressBar.classList.add(classLabel);
    }
    
    setProgressWidthAndText(freeShipBar, text, classLabel) {
        this.resetProgressClass(classLabel);
        this.progressMeter.style.width = `${freeShipBar}%`;
        if (this.textEnabled) {
            const label = this.progressMeter.querySelector('.text');
            if (label) label.textContent = `${freeShipBar.toFixed(2)}%`;
        }
        this.messageElement.innerHTML = text;
    }
}

window.addEventListener('load', () => {
    customElements.define('free-shipping-component', FreeShippingMeter);
})
